module.exports = __webpack_public_path__ + "img/AT0000034042182.9075c78d.png";